import { useInfiniteQuery } from '@tanstack/react-query';

import { orderAPI } from '../api/orderAPI';
import { ordersAdapter } from '../libs/orderAdapater';

/** Просим столько; бэкенд сейчас всё равно отдаёт по 5 — лишнее не вредит. */
const ORDERS_PER_PAGE = 10;

/**
 * Список заказов постранично для экрана «Мои заказы»: страницы дописываются
 * к уже показанным, `meta.has_next` говорит, есть ли ещё.
 *
 * Ключ начинается с 'orders', как у useGetOrders: отмена заказа инвалидирует
 * `['orders']`, и по префиксу это накрывает и постраничный список.
 */
export const useGetOrdersPaginated = (enabled = true) => {
  const query = useInfiniteQuery({
    queryKey: ['orders', 'paginated'],
    initialPageParam: 1,
    queryFn: async ({ pageParam }) =>
      (await orderAPI.getOrdersPage(pageParam, ORDERS_PER_PAGE)).data,
    getNextPageParam: last => (last.meta?.has_next ? last.meta.page + 1 : undefined),
    enabled,
    // Экран открывается сразу после оформления заказа — показывать кэш,
    // собранный до него, нельзя.
    refetchOnMount: 'always',
  });

  // Один заказ может приехать дважды, если между страницами появился новый и
  // сдвинул выдачу — оставляем первое вхождение.
  const seen = new Set<number>();
  const orders = ordersAdapter(
    (query.data?.pages ?? []).flatMap(page => page.data ?? [])
  ).filter(order => {
    if (seen.has(order.id)) return false;
    seen.add(order.id);
    return true;
  });

  return {
    orders,
    isLoading: query.isLoading,
    isError: query.isError,
    hasMore: Boolean(query.hasNextPage),
    loadMore: query.fetchNextPage,
    isLoadingMore: query.isFetchingNextPage,
  };
};
